import React from 'react';
import { JobResult } from './types.d';
import { JobResultRow } from './JobResultRow';
import { Page, Pagination } from './Pagination';

import '@zr/zds/src/zds.min.css';
import './JobResults.less';

export type JobResultsProps = {
  jobList: Array<JobResult>;
  jobCount: number;
  currentPage: number;
  maxPages: number;
  pageSize: number;
  placementId: string;
  impressionSuperSetId: string;
  isEligibleForOneClickApply?: boolean;
};

const getLinkForPage = (page: number) => {
  const currentPageURL = new URL(window.location.href);
  currentPageURL.searchParams.set('page', `${page}`);
  return currentPageURL.toString();
};

const JobResults = ({
  jobList,
  jobCount,
  currentPage,
  maxPages,
  pageSize,
  placementId,
  impressionSuperSetId,
  isEligibleForOneClickApply = false,
}: JobResultsProps): JSX.Element | null => {
  if (!jobList || !jobList.length) {
    return null;
  }

  const pages: Array<Page> = new Array(maxPages).fill(undefined).map((_, i) => ({
    pageNumber: i + 1,
    href: getLinkForPage(i + 1),
  }));

  return (
    <div className="job_results" data-testid="job-results-root">
      {jobList.map((j) => (
        <JobResultRow
          key={j.Href}
          job={j}
          placementId={placementId}
          impressionSuperSetId={impressionSuperSetId}
          isEligibleForOneClickApply={isEligibleForOneClickApply}
        />
      ))}
      {maxPages > 1 && (
        <div className="pagination_container">
          <Pagination
            variant="simple"
            currentPage={currentPage}
            maxPages={maxPages}
            pageSize={pageSize}
            resultCount={jobCount}
            pages={pages}
          />
        </div>
      )}
    </div>
  );
};

export default JobResults;
